// ReviewSection.jsx
import React, { useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';
const ReviewSection = ({ propertyId }) => {
  const [reviewsHtml, setReviewsHtml] = useState(""); // ใช้แทน innerHTML เดิม
const { t } = useTranslation();
  useEffect(() => {
    if (!propertyId) return;

    fetch(`https://summerhousagentlive.onrender.com/api/reviews/${propertyId}`)
      .then(res => res.json())
      .then(data => {
        // แปลง array ของรีวิวเป็น HTML string (ถ้าจำเป็น)
        const htmlContent = data.map(r => `
          <div>
            <p>${r.reviewer_name}</p>
            <p>${r.review_text}</p>
          </div>
        `).join("");
        setReviewsHtml(htmlContent);
      });
  }, [propertyId]);

  return (
    <div>
      <h3>{t('Reviews')}</h3>
      {/* แสดงผลโดยใช้ state แทน innerHTML */}
      <div dangerouslySetInnerHTML={{ __html: reviewsHtml }} />
    </div>
  );
};

export default ReviewSection;
